<button mat-flat-button color="primary" (click)="addAccessories()">{{ 'AWNING|Dodaj akcesoria' | translate }}</button>

@if (accessories?.length > 0) {
  <div class="icc-list">
    <h4>{{ 'AWNING|Akcesoria' | translate }}</h4>
    @for (accessory of accessories; track accessory) {
      <div class="icc-list-item">
        <img [src]="accessory?.imageUrl" [alt]="accessory?.name" defaultImg>
        <div class="info-content">
          <ng-container>{{ accessory?.title }}</ng-container>
          <p class="item-action">
            <button mat-raised-button color="primary" (click)="removeAccessory(accessory)">{{ 'INTERFACE|Usuń'| translate }}</button>
          </p>
        </div>
      </div>
    }
  </div>
}